import "core-js/modules/web.dom.iterable";
/**
 * checkbox-indeterminate mixin
 * 带全选功能的复选框组
 */

export default {
  data: function data() {
    return {
      checkboxData: [],
      // 复选框数据 [{value:xxx, label:xxx}]
      checkAllGroup: [],
      // 已勾选数据 [value]
      checkAll: false,
      // 是否全选
      indeterminate: false // 是否半选
    };
  },
  methods: {
    // 计算 全选、半选状态
    getCheckAllStatus: function getCheckAllStatus() {
      var allLen = this.checkboxData.length;
      var checkedLen = this.checkAllGroup.length;
      if (allLen < 1) {
        this.checkAll = false;
        this.indeterminate = false;
        return false;
      }
      if (checkedLen < 1) {
        this.checkAll = false;
        this.indeterminate = false;
        return false;
      }
      if (checkedLen < allLen) {
        this.checkAll = false;
        this.indeterminate = true;
        return false;
      }
      this.checkAll = true;
      this.indeterminate = false;
    },
    // 点击全选
    handleCheckAll: function handleCheckAll() {
      var _this = this;
      this.checkAll = !this.checkAll;
      this.indeterminate = false;
      this.checkAllGroup.splice(0);
      this.checkboxData.forEach(function (item) {
        item._checked = _this.checkAll;
        item._checked && _this.checkAllGroup.push(item.value);
      });
    }
  }
};